/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from "@ember/service";
import BaseMedicalHistoryFormComponent from "parog-web/components/medical-history/abstract/base-edition-form";
import { type SemeiaMedicSession } from "parog-web/services/session";
import MedicalHistoryBaseEditionForm from "../base-edition-form";

export default class MedicalHistoryEditionFormComponent extends BaseMedicalHistoryFormComponent {
  MedicalHistoryBaseEditionForm = MedicalHistoryBaseEditionForm;

  @service declare session: SemeiaMedicSession;

  journalEventProperties = [
    ...this.sharedProperties,
    "diagnosisDate",
    "side",
    "stage",
    "tnmClassification",
    "tnmComment",
    "histology",
    "her2",
    "fertilityPreservation",
    "oncogeneticConsultation",
    "estrogenReceptor",
    "progesteroneReceptor",
    "pelvicSonogram",
    "ki67",
    "donorType",
    "hemato-cancer-type",
    "maritalStatus",
    "hasChildren",
    "children",
    "job",
    "relapse",
    "tripleNegative",
    "familyHistoryBreastCancer",
    "familyHistoryBreastCancerMember",
    "familyHistoryOvarianCancer",
    "familyHistoryOvarianCancerMember",
    "brca1",
    "brca1Member",
    "brca2",
    "brca2Member",
    "otherCancer",
    "otherCancerType",
    "menopause",
    "contraception",
    "cellCancerType",
    "nonSmallCellCancerType",
    "mutation",
    "statutPDL1",
    "smokingPatients",
    "lungCancerFamily",
    "chronicBronchopneumopathy",
    "pancreaticCancerType",
    "pancreaticMutation",
    "familialPancreaticCancer",
    "hereditaryChronicPrss1GeneMutation",
    "familyHistoryProstateCancer",
    "familyHistoryProstateCancerMember",
    "prostateCancerType",
    "hormoneSensitiveCancer",
    "prostateMutation",
    "gleasonScore",
    "smokingCessation"
  ];

  retrieveModel(): Record<string, unknown> {
    const model = super.retrieveModel() as {
      tnmClassification;
      estrogenReceptor;
      progesteroneReceptor;
      children;
    };

    model.tnmClassification ??= {};
    model.estrogenReceptor ??= {};
    model.progesteroneReceptor ??= {};
    model.children ??= [];

    if (this.args.patient.hasBreastCancer)
      model.tnmClassification.m =
        `${this.args.patient.followUpReasonRecord?.id}`.endsWith("tnm0")
          ? "M0"
          : "M1";

    return model;
  }
}
